var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#fe6000",
    d: "M 25.5,-0.5 C 26.1667,-0.5 26.8333,-0.5 27.5,-0.5C 27.6657,3.84611 27.499,8.17944 27,12.5C 23.6039,15.3928 20.7706,18.7261 18.5,22.5C 21.2198,24.1107 24.2198,24.944 27.5,25C 12.4553,44.9401 6.62192,42.4401 10,17.5C 10.6667,16.1667 11.3333,14.8333 12,13.5C 16.7033,8.96455 21.2033,4.29788 25.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#fe6000",
    d: "M 23.5,47.5 C 22.8333,47.5 22.1667,47.5 21.5,47.5C 20.8875,43.837 20.7208,40.1703 21,36.5C 24.1667,32.6667 27.3333,28.8333 30.5,25C 29.8333,24.3333 29.1667,23.6667 28.5,23C 26.0995,22.8142 23.7662,22.3142 21.5,21.5C 37.496,2.26391 43.3293,5.26391 39,30.5C 33.9958,36.3365 28.8292,42.0031 23.5,47.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlint);
export default __webpack_public_path__ + "static/media/flint.c8505172c01714b839a90f4c3cc8e34b.svg";
export { ForwardRef as ReactComponent };